import { get, post, del } from '../../api-config';
import { gdpService, getLocale } from './_service';

// Etiquetas de campo sobrescritas para el grupo del usuario logueado. Devuelve solo
// los códigos configurados: si viene vacío, mandan los literales del i18n.
export const getFieldLabels = () => get(gdpService, '/field-labels', null, { locale: getLocale() });

// data loading tables sections with or without filters
export const postDataTables = (filters: any, pathname: any) =>
  post(gdpService, `/${pathname}/search`, filters, null);

// delete user, professional, device, relative
export const delByPathId = (path: any, id: any) => del(gdpService, `/${path}/${id}`);
